module.exports = __webpack_public_path__ + "static/media/Artboard.7c895346.png";